import React, { useEffect,useState } from "react";
import { Modal, Form, Input, Select, InputNumber,Button} from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModel } from "../../../models";
import {decoder,filterPayType} from "../../../utils/decoder"

let { Option } = Select
const TiaoEr = () => {
    const [form] = Form.useForm();
    const [{ selectedAccount, selectedSupplierBill,ModelVisible}, { adjustAccount, setModelVisible }] = useModel("supplierBill");

    const [{ accountTyprDict }, { getAccountTyprDict }] = useModel("cmDict");
    useEffect(() => {
        // console.log(selectedSupplier,selectedAccount)
        // let aaa = ""
        // accountTyprDict.forEach(item=>{
        //     if(item.key==selectedSupplier.accountType){
        //         console.log(item)
        //         return aaa = item.label
        //     }
        // })
        // console.log(aaa)
        form.setFieldsValue({ ...selectedAccount, ...selectedSupplierBill });
        form.setFieldsValue({accountType:"授信账户"});
    }, [selectedAccount]);
    const _onFinish = () => {
        form.validateFields().then(datas => {
            // return console.log(datas)
            let { id } = selectedAccount
            let data = {
                ...datas,
                id,
                accountType:selectedAccount.accountType
            }
            adjustAccount({ data }).then(() => {
                // setAdjustModelVisible(false);
                setModelVisible(!ModelVisible)

            });

        })
    }
    
    const cancel = () => {
        form.resetFields();
        setModelVisible(!ModelVisible)

    }    
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{ span: 6 }}
            onFinish={_onFinish}
            style={{ marginRight: "50px" }}
        >
            <Form.Item
                name="supplierName"
                label="供应商名称"
            >
                <Input disabled={true} placeholder="供应商名称" />
            </Form.Item>
            <Form.Item
                name="accountType"
                label="账户类型"
            >
                <Input disabled={true} placeholder="账户类型" />
            </Form.Item>
            <Form.Item
                name="creditLine"
                label="授信额度"
            >
                <Input disabled={true} placeholder="授信额度" />
            </Form.Item>
            <Form.Item
                name="adjustmentlimit"
                label="调整额度"
                rules={[{ required: true, message: '调整额度是必输项', }]}
            >
                <InputNumber placeholder="调整额度" />
            </Form.Item>
            <Form.Item
                name="remarks"
                label="备注"
            // labelCol={{span: 3}}
            >
                <Input placeholder="备注" />
            </Form.Item>
            <Form.Item style={{ textAlign: "right" }}>
                <Button className="margin-left-8" onClick={cancel}>取消</Button>
                <Button className="margin-left-8" type="primary" htmlType="submit">确定</Button>
            </Form.Item>
        </Form>
    )
}
const ChoZhi = () => {
    const [{selectedAccount, selectedSupplierBill,ModelVisible}, { adjustAccount, setModelVisible,fillAccount}] = useModel("supplierBill");
    const [{payTypeDict,accountTypeDict}, {getPayTypeDict}] = useModel("cmDict");
    const [form] = Form.useForm();
    useEffect(() => {
        getPayTypeDict();
    }, []);
    useEffect(() => {
        // console.log(selectedAccount)
        if(!!selectedAccount){
            form.setFieldsValue({...selectedSupplierBill,...selectedAccount});
            form.setFieldsValue({accountType:decoder(accountTypeDict,selectedAccount.accountType)})
        }

        // return () => {
        //     form.setFieldsValue({})
        //   };
    }, [selectedAccount]);
    const cancel = () => {
        setModelVisible(!ModelVisible)
    }
    const _onFinish = (value) => {

        form.validateFields().then(datas => {
            // console.log(data)
            let { id } = selectedAccount
            let data = {
                ...datas,
                id,
                accountType:selectedAccount.accountType
            }
            fillAccount({data}).then(() => {
                // setAdjustModelVisible(false)
                setModelVisible(!ModelVisible)
                //重新加载账户
            });
        })
    }
    return (
        <Form
        form={form}
        onFinish={_onFinish}
        name="material_detail"
        labelCol={{span: 6}}
        style={{marginRight: "50px"}}
    >
                  <Form.Item
                        name="supplierName"
                        label="供应商名称"
                    >
                        <Input disabled={true} placeholder="供应商名称" />
                    </Form.Item>
                    <Form.Item
                        name="accountType"
                        label="账户类型"
                        rules={[{ required: true, message: '账户类型是必选项', }]}
                    >
                        <Input disabled={true} placeholder="账户类型" />
                    </Form.Item>
                    <Form.Item
                        name="remainingAmount"
                        label="剩余金额"
                    >
                        <Input disabled={true} placeholder="剩余金额" />
                    </Form.Item>
                    <Form.Item
                        name="rechargeAmount"
                        label="充值金额"
                        rules={[{ required: true, message: '充值金额是必输项', }]}
                    >
                        <InputNumber placeholder="充值金额" />
                    </Form.Item>
                    <Form.Item
                        name="paymentMethod"
                        label="支付方式"
                        rules={[{ required: true, message: '充值方式是必输项', }]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择支付方式"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={filterPayType(payTypeDict)}
                        />
                    </Form.Item>
                    <Form.Item
                        name="remarks"
                        label="备注"
                    >
                        <Input placeholder="备注" />
                    </Form.Item>
                    <Form.Item style={{ textAlign: "right" }}>
                <Button className="margin-left-8" onClick={cancel}>取消</Button>
                <Button className="margin-left-8" type="primary" htmlType="submit">确定</Button>
            </Form.Item>
        </Form>
    )
}
const ZhuanZhang = () => {
    const [{accountList, selectedSupplierBill,ModelVisible}, {transferAccount, setModelVisible}] = useModel("supplierBill");
    const [{payTypeDict,accountTypeDict}] = useModel("cmDict");
    const [form] = Form.useForm();
    const initOptions = accountList.map(el => ({key: el.id, label: decoder(accountTypeDict,el.accountType), value: el.id}));
    const [sourceAccountOptions, setSourceAccountOptions] = useState(initOptions);
    const [targetAccountOptions, setTargetAccountOptions] = useState(initOptions);
    useEffect(()=>{
        form.setFieldsValue({...selectedSupplierBill});
    },[selectedSupplierBill])
    const cancel = () => {
        setModelVisible(!ModelVisible)
    }
    const _onFinish = (value) => {

        form.validateFields().then(datas => {
            // console.log(data)
            let { id } = selectedSupplierBill
            let data = {
                ...datas,
                id
            }
            transferAccount({data}).then(() => {
                // setAdjustModelVisible(false)
                setModelVisible(!ModelVisible)

            });
        })
    }
    const onSourceAccountChange = (value) => {
        const selectedSourceAccount = accountList.filter(el => el.id === value);
        if (selectedSourceAccount && selectedSourceAccount.length > 0) {
            form.setFieldsValue({sourceAccountBalance: selectedSourceAccount[0].remainingAmount});
        }
        const filteredTargetOptions = initOptions.filter(el => !(el.key === value));
        setTargetAccountOptions(filteredTargetOptions)
    }
    const onTargetAccountChange = (value) => {
        const selectedTargetAccount = accountList.filter(el => el.id === value);
        if (selectedTargetAccount && selectedTargetAccount.length > 0) {
            form.setFieldsValue({targetAccountBalance: selectedTargetAccount[0].remainingAmount});
        }
        setSourceAccountOptions(initOptions.filter(el => !(el.key === value)));
    }
    return (
        <Form
        form={form}
        onFinish={_onFinish}
        name="material_detail"
        labelCol={{span: 6}}
        style={{marginRight: "50px"}}
    >
             <Form.Item
                    name="supplierName"
                    label="供应商名称"
                >
                    <Input disabled={true} placeholder="客户名称"/>
                </Form.Item>            
                <Form.Item
                    name="transferOutId"
                    label="转出账户"
                    rules={[{required: true, message: '转出账户是必输项',}]}
                >
                    <Select
                        showSearch
                        allowClear={true}
                        placeholder="选择转出账户"
                        filterOption={(input, option) => option.label.indexOf(input) >= 0}
                        onChange={onSourceAccountChange}
                        options={sourceAccountOptions}
                    />
                </Form.Item>
                <Form.Item
                    name="transferToId"
                    label="转入账户"
                    rules={[{required: true, message: '转入账户是必输项',}]}
                >
                    <Select
                        showSearch
                        allowClear={true}
                        placeholder="选择转入账户"
                        filterOption={(input, option) => option.label.indexOf(input) >= 0}
                        onChange={onTargetAccountChange}
                        options={targetAccountOptions}
                    />
                </Form.Item>
                <Form.Item
                    name="transferAmount"
                    label="转账金额"
                    rules={[{required: true, message: '转账金额是必输项',}]}
                >
                    <InputNumber placeholder="转账金额"/>
                </Form.Item>
                <Form.Item
                    name="remarks"
                    label="备注"
                >
                    <Input placeholder="备注"/>
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                <Button className="margin-left-8" onClick={cancel}>取消</Button>
                <Button className="margin-left-8" type="primary" htmlType="submit">确定</Button>
            </Form.Item>                
    </Form>
    )
}
const ModelCont = {
    "tiaoer": <TiaoEr />,
    "chozhi": <ChoZhi />,
    "zhuanzhang": <ZhuanZhang />,
}
const SupplierModel = () => {
    const [{ ModelVisible, ModelParams }, { setModelVisible, setModelParams }] = useModel('supplierBill')
    const handleOk = (e) => {//确认按钮
        // console.log("确认")
        setModelVisible(!ModelVisible)
    };
    const handleCancel = (e) => {//取消按钮
        // console.log("取消")
        setModelVisible(!ModelVisible)
    }
    return (
        <Modal
            title={ModelParams.title}
            visible={ModelVisible}
            footer={null}
            onOk={handleOk}
            onCancel={handleCancel}
        >
            {/* <TiaoEr></TiaoEr> */}
            {/* <ChoZhi></ChoZhi> */}
            {/* <ZhuanZhang></ZhuanZhang> */}
            {ModelCont[ModelParams.type]}
        </Modal>
    )
}
export default SupplierModel